import React, {ReactElement, Component, useState, useEffect, Dispatch, SetStateAction, useContext} from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import {Button, Select} from "antd";
import {PlusOutlined} from '@ant-design/icons';
import {
    getPopupNode,
    loading_alert_after,
    loading_alert_before,
    http_get,
    http_post,
    alert, http_put, format_time,
} from '../common-file/service';
import RectangleCardItem from '../component/rectangle-card-item';
import TableList from "../component/table";
import SearchInput from '../component/search-input';
import Modals from '../component/modal';

import {ServiceNameContext} from '../contexts/service-name-select';
import {SearchValueContext} from '../contexts/search-value';
import {modalDataType, modalType} from "../common-file/interfaceType";
import {ModalVisibleContext} from "../contexts/modal-visible";
// import {DataCenterNameContext} from "../contexts/dataCenter-select";
import {ModalDataContext} from "../contexts/modal-data";
import { DatacenternameContext } from "../../../contexts/datacenter-name";
// import {AppLocationContext} from "../contexts/app-location";
import {ModalLoadingContext} from "../contexts/modal-loading";

interface topCardType {
    totalClusters?: number|string|undefined|JSX.Element,
    runningClusters?: number|string|undefined|JSX.Element,
    detachedClusters?: number|string|undefined|JSX.Element,
    instancesQuota?: number|string|undefined|JSX.Element,
    remainInstances?: number|string|undefined|JSX.Element,
    runningInstances?: number|string|undefined|JSX.Element,
    detachedInstances?: number|string|undefined|JSX.Element,
    totalActive?: number|string|undefined|JSX.Element,
    totalInactive?: number|string|undefined|JSX.Element,
    totalInprogress?: number|string|undefined|JSX.Element
}

interface tableItemType {
    datacenterCode: number|string|undefined|JSX.Element,
    instanceDetached: number|string|undefined|JSX.Element,
    instanceQuota: number|string|undefined|JSX.Element,
    instanceRemain: number|string|undefined|JSX.Element,
    instanceRunning: number|string|undefined|JSX.Element,
    pseudoId: number|string|undefined|JSX.Element,
    status: number|string|undefined|JSX.Element,
    subscriptionName: number|string|undefined|JSX.Element,
    company: number|string|undefined|JSX.Element,
    serviceInstanceId: number|string|undefined|JSX.Element,
    serviceInstanceName: number|string|undefined|JSX.Element,
    createdAt: number|string|undefined|JSX.Element,
    planName: number|string|undefined|JSX.Element,
    deploymentName: number|string|undefined|JSX.Element,
}

const top_card_data: topCardType = {
    totalClusters: 'loading',
    runningClusters: 'loading',
    detachedClusters: 'loading',
    instancesQuota: 'loading',
    remainInstances: 'loading',
    runningInstances: 'loading',
    detachedInstances: 'loading'
};

const dedicated_data: any = {
    totalClusters: true,
    totalActive: true,
    totalInactive: true,
    totalInprogress: true
};

const shared_data: any = {
    totalClusters: true,
    runningClusters: true,
    detachedClusters: true,
    instancesQuota: true,
    remainInstances: true,
    runningInstances: true,
    detachedInstances: true
};

const hide_deleted_none: any = {
    deleted: true,
    none: true
};

// const action_dedicated = {
//     view: true,
//     monitoring: true,
//     detach_cluster: true,
//     delete_cluster: true
// };
//
// const action_shared = {
//     view: true,
//     monitoring: true,
//     detach_cluster: true,
//     delete_cluster: true,
//     resume_cluster: true
// };

const service_name_data: any ={
    // All:['Dedicated', 'Shared'],
    PostgreSQL: ['Shared', 'Dedicated'],
    MongoDB: ['Shared', 'Dedicated'],
    // RabbitMQ: ['standard', 'Dedicated']
};

const columns_dedicated =['status', 'subscription_name', 'company', 'instance_name', 'instance_id', 'deployment_name', 'plan','create_time'];
const columns_shared =['status', 'pseudo_id', 'quota', 'remain', 'running', 'detached'];

const ResourceOverview: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> => {

    const {intl} =props,
        [service_name, set_service_name]: [string, Dispatch<SetStateAction<string>>] = useContext(ServiceNameContext),
        [cluster_type, set_cluster_type]: [string, Dispatch<SetStateAction<string>>] = useState(sessionStorage.getItem('service_cluster_type')||'Shared'),
        [cluster_type_list, set_cluster_type_list]: [any, Dispatch<SetStateAction<any>>] = useState([]),
        search_value: any = useContext(SearchValueContext)[0],
        [filter_list, set_filter_list]: [any, Dispatch<SetStateAction<any>>] = useState(null),
        [top_card_list, set_top_card_list]: [topCardType, Dispatch<SetStateAction<topCardType>>] = useState(top_card_data),
        // dataCenter_name: string = useContext(DataCenterNameContext)[0],
        datacenter_name: string | undefined = useContext(DatacenternameContext)[0],
        // app_location: string = useContext(AppLocationContext)[0],
        set_modal_loading: Dispatch<SetStateAction<boolean>> = useContext(ModalLoadingContext)[1],
        [reload_list, set_reload_list]: [boolean, Dispatch<SetStateAction<boolean>>] = useState(()=> true),
        [modal_visible, set_modal_visible]: [modalType, Dispatch<SetStateAction<modalType>>] = useContext(ModalVisibleContext),
        [modal_data, set_modal_data]: [modalDataType, Dispatch<SetStateAction<modalDataType>>] = useContext(ModalDataContext),
        [table_list, set_table_list]: [any, Dispatch<SetStateAction<any>>] = useState(null);

    useEffect(()=>{
        if (search_value.overview && table_list) {
            const filter: any = table_list.filter((item: any) => ((cluster_type === 'Shared' ? item.pseudoID: item.deploymentName)||'').indexOf(search_value.overview) >= 0);
            set_filter_list(filter);
        } else {
            set_filter_list(table_list);
        }
        // eslint-disable-next-line
    }, [search_value, table_list]);

    useEffect(()=>{
        if(service_name_data[service_name]){
            set_cluster_type_list(service_name_data[service_name]);
            sessionStorage.setItem('service_name', service_name);
        }else {
            const session_service_name: string = sessionStorage.getItem('service_name') || 'PostgreSQL',
                new_session_service_name: string = service_name_data[session_service_name]? session_service_name: 'PostgreSQL';
            set_service_name(new_session_service_name);
            sessionStorage.setItem('service_name', new_session_service_name);
        }

        const return_service_name = ()=>{
            return service_name === 'RabbitMQ'? 'standard': 'Shared';
        };

        if(service_name_data[service_name]){
            const filter_list: any = service_name_data[service_name].filter((item: string)=> item === cluster_type);
            filter_list.length <= 0 && set_cluster_type(return_service_name()) && sessionStorage.setItem('service_cluster_type', return_service_name())
        }else {
            cluster_type === 'standard' && set_cluster_type('Shared') && sessionStorage.setItem('service_cluster_type', 'Shared')
        }
        set_reload_list(true);
        // eslint-disable-next-line
    }, [service_name]);

    useEffect(()=>{
        if(modal_visible.toggle){
            let title: string ='', content='', type= '', itemValue= {};
            switch (modal_visible.type){
                case 'cancel': title = 'confirm';
                    content = 'sure_to_cancel';
                    type = 'cancel';
                    break;
                case 'create': title = cluster_type === 'Dedicated'? 'overview_create_dedicated': "overview_create_shared";
                    type = 'create';
                    title === 'overview_create_shared' && (itemValue = {
                        overview_service_name: service_name,
                        overview_plan: cluster_type
                    });
                    break;
                case 'rename': title = 'rename_instance_overview';
                    type = 'rename';
                    break;
                default: break;
            }
            title && set_modal_data({
                title,
                type,
                itemValue,
                confirmContent: content,
                datasource: table_list
            })
        }
        // eslint-disable-next-line
    }, [modal_visible, set_modal_data]);

    const return_cluster_type = ()=>{
        return cluster_type === 'Dedicated'? 'Dedicated-Single-Small': cluster_type
    };

    const return_number_unlimited = (num1?: number|string|undefined|JSX.Element, num2?: number|string|undefined|JSX.Element, type?: string)=>{
        if(num1 === -1 && num2 === -1) {
            switch (type) {
                case 'element':
                    return <FormattedMessage id={'unlimited'}/>;
                case 'string':
                    return 'unlimited';
                default:
                    return num1;
            }
        }else{
            return num1;
        }
    };

    useEffect(()=>{
        if(service_name_data[service_name] && cluster_type && datacenter_name && reload_list){
            set_top_card_list(top_card_data);
            set_reload_list(false);
            (async ()=>{
                loading_alert_before();
                const {data} = await http_get(`/serviceHub/v2/datacenterCode/${datacenter_name}/overview?serviceName=${service_name}&planName=${return_cluster_type() }&datacenterCode=${datacenter_name}`, props) as any || {};
                if(data){
                    const {totalRunning, totalDetached, totalClusters, instance, totalActive, totalInactive, totalInprogress} = data,
                        {quota, totalRemain} = instance,
                        detachedInstance: number|undefined = instance.totalDetached,
                        runningInstance: number|undefined = instance.totalRunning;
                    set_top_card_list({
                        totalClusters: totalClusters,
                        runningClusters: totalRunning,
                        detachedClusters: totalDetached,
                        instancesQuota: return_number_unlimited(quota, totalRemain, 'string'),
                        remainInstances: return_number_unlimited(totalRemain, quota, 'string'),
                        runningInstances: runningInstance,
                        detachedInstances: detachedInstance,
                        totalActive,
                        totalInactive,
                        totalInprogress
                    })
                }else {
                    set_top_card_list({
                        totalClusters: 'noData',
                        runningClusters: 'noData',
                        detachedClusters: 'noData',
                        instancesQuota: 'noData',
                        remainInstances: 'noData',
                        runningInstances: 'noData',
                        detachedInstances: 'noData',
                        totalActive: 'noData',
                        totalInactive: 'noData',
                        totalInprogress: 'noData'
                    })
                }
                loading_alert_after();
            })();
            (async ()=>{
                loading_alert_before();
                set_table_list([]);
                const {data} = await http_get(`/serviceHub/v2/cluster/list?serviceName=${service_name}&planName=${return_cluster_type()}&datacenterCode=${datacenter_name}`, props) as any || {};
                if(data){
                    const new_table: any = [];
                    // eslint-disable-next-line
                    data.map((item: tableItemType)=>{
                        const {
                            serviceInstanceId,
                            serviceInstanceName,
                            datacenterCode,
                            instanceDetached,
                            instanceQuota,
                            instanceRemain,
                            instanceRunning,
                            pseudoId,
                            status,
                            subscriptionName,
                            company,
                            planName,
                            createdAt,
                            deploymentName
                        } = item;
                        // 不显示status === deleted项
                        (!hide_deleted_none[(status as string || '').toLowerCase()])&&new_table.push({
                            key: pseudoId,
                            status,
                            datacenterCode,
                            instanceId: serviceInstanceId,
                            instanceName: serviceInstanceName,
                            pseudoID: pseudoId,
                            plan: planName,
                            quota: return_number_unlimited(instanceQuota, instanceRemain, 'element'),
                            remain: return_number_unlimited(instanceRemain, instanceQuota, 'element'),
                            running: instanceRunning,
                            detached: instanceDetached,
                            subscriptionName,
                            company,
                            deploymentName,
                            createTime: createdAt?format_time(createdAt): ''
                        })
                    });
                    set_table_list(new_table);
                }
                loading_alert_after();
            })()
        }
        // eslint-disable-next-line
    }, [service_name, cluster_type, datacenter_name, reload_list]);


    useEffect(()=>{
        if(modal_data.formValue){
            switch (modal_data.title) {
                case 'overview_create_dedicated':
                    (async ()=>{
                        const {
                            // subscriptionId,
                            authenticationDatabase,
                            bindable,
                            // chargeType,
                            dashboardUrl,
                            // dataService,
                            databaseVersion,
                            externalHosts,
                            internalHosts,
                            location,
                            parameters,
                            password,
                            persistentDiskSize,
                            persistentDiskType,
                            // serviceCategory,
                            serviceInstanceId,
                            // serviceInstanceName,
                            // serviceNameInstance,
                            // servicePlanName,
                            // serviceProperty,
                            ssl,
                            // transactionId,
                            // userId,
                            username,
                            vmSize,
                            vmType,
                        } = modal_data.formValue,
                            form_data: object ={
                                // subscriptionId: subscriptionId,
                                serviceInstanceId: serviceInstanceId,
                                // serviceInstanceName: serviceInstanceName,
                                // serviceCategory: serviceCategory || null,
                                // transactionId: transactionId,
                                // userId: userId || null,
                                // serviceName: serviceNameInstance,
                                datacenterCode: datacenter_name,
                                // servicePlanName: servicePlanName,
                                bindable: bindable || 'true',
                                parameters: parameters,
                                dashboardUrl: dashboardUrl || null,
                                // serviceProperty: serviceProperty || null,
                                // chargeType: chargeType || null,
                                // pnInfo: dataService,
                                internalHosts: internalHosts,
                                externalHosts: externalHosts,
                                ssl: ssl === 'true',
                                username: username,
                                password: password,
                                authenticationDatabase: authenticationDatabase || null,
                                deploymentProperties: {
                                    location: location || null,
                                    databaseVersion: databaseVersion || null,
                                    vmType: vmType || null,
                                    vmSize: vmSize || null,
                                    persistentDiskSize: Number(persistentDiskSize) || null,
                                    persistentDiskType: persistentDiskType || null
                                }
                            };
                        loading_alert_before();
                        const create_dedicated: any = await http_put('/serviceHub/v2/serviceInstances/manual', form_data, props);
                        if(create_dedicated) {
                            set_reload_list(true);
                            set_modal_visible({toggle: false});
                            alert('success', intl.formatMessage({id: modal_data.title}), intl.formatMessage({id: 'create_success_sp'}))
                        }else {
                            set_modal_loading(false)
                        }
                        loading_alert_after();
                    })();
                    break;
                case 'overview_create_shared':
                    (async ()=>{
                        const {
                            externalHosts,
                            databaseVersion,
                            datacenterCode,
                            internalHosts,
                            location,
                            authenticationDatabase,
                            overviewServiceName,
                            overviewPlan,
                            parameters,
                            password,
                            persistentDiskSize,
                            persistentDiskType,
                            pseudoID,
                            ssl,
                            username,
                            vmType,
                            vmSize
                        } = modal_data.formValue,
                            form_data: object ={
                                serviceName: overviewServiceName,
                                planName: overviewPlan,
                                pseudoId: pseudoID,
                                datacenterCode: datacenterCode,
                                internalHosts: internalHosts,
                                externalHosts: externalHosts,
                                username: username,
                                password: password,
                                authenticationDatabase: authenticationDatabase || null,
                                ssl: ssl === 'true',
                                parameters: parameters,
                                deploymentProperties: {
                                    location: location || null,
                                    databaseVersion: databaseVersion || null,
                                    vmType: vmType || null,
                                    vmSize: vmSize || null,
                                    persistentDiskSize: Number(persistentDiskSize) || null,
                                    persistentDiskType: persistentDiskType || null
                                }
                            };
                        loading_alert_before();
                        const create_shared: any= await http_post('/serviceHub/v2/clusters/shared', form_data, props);
                        if(create_shared) {
                            set_reload_list(true);
                            set_modal_visible({toggle: false});
                            alert('success', intl.formatMessage({id: modal_data.title}), intl.formatMessage({id: 'create_success_sp'}))
                        }else {
                            set_modal_loading(false)
                        }
                        loading_alert_after();
                    })();
                    break;
                case 'rename_instance_overview':
                    (async () => {
                        loading_alert_before();
                        const {instanceId} = JSON.parse(sessionStorage.getItem('overview_list_item_selected') || '{}'),
                            {serviceInstanceName} = modal_data.formValue,
                            rename_res: any = await http_put(`/serviceHub/v2/serviceInstances/${instanceId}`, {serviceInstanceName: serviceInstanceName}, props);
                        if (rename_res) {
                            set_reload_list(true);
                            set_modal_visible({toggle: false});
                        } else {
                            set_modal_loading(false)
                        }
                        loading_alert_after();
                    })();
                    break;
                default: break;
            }
        }
        // eslint-disable-next-line
    }, [modal_data, set_modal_visible]);

    return (
        <div>
            <div className={'content-top-form service-portal'}>
                <div className={'content-top-form-item'}>
                    <span className={'top-item-label'}>
                        <FormattedMessage id={'service_name'}/>
                        <FormattedMessage id={':'}/>
                    </span>
                    <Select
                        value={service_name_data[service_name] ? service_name : 'PostgreSQL'}
                        onChange={(val: string)=> {
                            set_service_name(val);
                            sessionStorage.setItem('service_name', val)
                        }}
                        getPopupContainer={()=>getPopupNode()}
                    >{Object.keys(service_name_data).map((key: string)=>(
                        <Select.Option key={key} value={key}>{key}</Select.Option>
                    ))}</Select>
                </div>
                <div className={'content-top-form-item'}>
                    <span className={'top-item-label'}>
                        <FormattedMessage id={'cluster_type'}/>
                        <FormattedMessage id={':'}/>
                    </span>
                    <Select
                        value={cluster_type || 'Shared'}
                        onChange={(val: string)=> {
                            set_cluster_type(val);
                            sessionStorage.setItem('cluster_type', val);
                            set_reload_list(true);
                        }}
                        getPopupContainer={()=>getPopupNode()}
                    >{cluster_type_list.map((item: string)=>(
                        <Select.Option key={item} value={item}>{item}</Select.Option>
                    ))}</Select>
                </div>
            </div>
            <div>
                <div className={'card_title management-label-line font-size-16'}>
                    <FormattedMessage id={'cluster_information'}/>
                </div>
                <div className="management-select-area w-100">
                    {cluster_type&&<div className={'rectangle-card-box'}>{
                        Object.keys(top_card_list).map((key: string)=> (
                            (cluster_type ==='Dedicated'? dedicated_data[key]: shared_data[key]) &&
                            <RectangleCardItem
                                key={key}
                                value={(top_card_list as any)[key]}
                                name={key}
                            />
                        ))
                    }</div>}
                    <div className="mt-20">
                    <div className={'card-search has-add'}>
                        <SearchInput placeholder={intl.formatMessage({id: cluster_type === 'Dedicated'? 'deployment_name': 'pseudo_id'})}/>
                    </div>
                    <Button type="primary" style={{height: '40px'}} onClick={() => set_modal_visible({toggle: true, type: 'create'})}><PlusOutlined /></Button>
                </div>
                </div>
            </div>
            <div className={'mt-20'}>
                {/* <div>
                    <div className={'card-search has-add'}>
                        <SearchInput placeholder={intl.formatMessage({id: cluster_type === 'Dedicated'? 'deployment_name': 'pseudo_id'})}/>
                    </div>
                    <Button type="primary" onClick={() => set_modal_visible({toggle: true, type: 'create'})}><PlusOutlined /></Button>
                </div> */}
                <div className="mt-10 no_pointer">
                    {(cluster_type === 'Shared' || cluster_type === 'standard') && <TableList
                        datasource={filter_list || table_list}
                        columns={columns_shared as any}
                        action={false as any}
                        // action={action_shared}
                    /> }
                    {cluster_type === 'Dedicated'&& <TableList
                        datasource={filter_list || table_list}
                        columns={columns_dedicated as any}
                        action={false as any}
                        // action={action_dedicated}
                    />}
                </div>
            </div>
            <Modals />
        </div>
    )
};

export default injectIntl(ResourceOverview);
